import { ParamMap } from '@angular/router';

export const entityParamExtractor = (params: ParamMap): IMonitoringRouteParams => ({
    entityId: params.get('entityId') == null ? undefined : Number(params.get('entityId')),
});

export interface IMonitoringRouteParams {
    entityId?: number;
}
